/**
 * VIP/会员相关接口
 */

import wetvKernel from '@tencent/wetv-kernel';
import { post, ApiResponse } from './api';
import { qua, beforeRequest, getAppid } from '../utils/apiUtils';
import { API_PATHS } from './apiPaths';

const { fetcher } = wetvKernel;
const { configInstace } = wetvKernel;
const { videoAppid } = getAppid();

export interface CreateGuidIntlResponse {
  guid?: string;
  ret?: number;
  msg?: string;
}

/**
 * 获取付费二维码
 */
export async function getPaidCode(body?: any, params?: any): Promise<ApiResponse<any>> {
  beforeRequest();
  return fetcher.get(`https://${configInstace?.vipDomain}/${API_PATHS.paidCode}`, body, {
    CSRF: true,
    originReturn: true,
    withCredentials: true,
    params: {
      ...params,
      'Q-UA': qua(),
      video_appid: videoAppid,
    },
  });
}

/**
 * 海外TV端预鉴权
 */
export async function processTVPreAuth(body?: any, params?: any): Promise<ApiResponse<any>> {
  beforeRequest();
  return fetcher.get(`https://${configInstace?.vipDomain}/${API_PATHS.ProcessTVPreAuth}`, body, {
    CSRF: true,
    originReturn: true,
    withCredentials: true,
    params: {
      ...params,
      'Q-UA': qua(),
      video_appid: videoAppid,
    },
  });
}

/**
 * 获取付费guid信息(应该是订单号相关的信息)
 */
export async function createGuidIntl(params?: any): Promise<CreateGuidIntlResponse> {
  beforeRequest();
  return fetcher.get(`https://${configInstace?.vipDomain}/${API_PATHS.CreateGuidIntl}`, params, {
    CSRF: true,
    originReturn: true,
    withCredentials: true,
    params: {
      ...params,
      'Q-UA': qua(),
      video_appid: videoAppid,
    },
  });
}

/**
 * 获取跨端支付结果（轮询）
 */
export async function getMsgIntl(params?: any): Promise<ApiResponse<any>> {
  beforeRequest();
  return fetcher.get(`https://${configInstace?.vipDomain}/${API_PATHS.GetMsgIntl}`, params, {
    CSRF: true,
    originReturn: true,
    withCredentials: true,
    params: {
      ...params,
      'Q-UA': qua(),
      video_appid: videoAppid,
    },
  });
}

/**
 * 会员开通Astro侧验证账号信息
 */
export async function checkChannelAccount(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.CheckChannelAccount, body, { params });
}
